module.exports = __webpack_public_path__ + "static/media/roulette_casino_evianaif-14446.2950a921.mp3";